export const brandInfoMenuData: any[] = [
  {
    color: 'red',
    link: 'global-brand-information',
    title: 'Global Catalog',
    allow: ['admin', 'catalog-edit'],
  },
  {
    color: 'red',
    link: 'account-information',
    title: 'Account Settings',
  }
];
